import React from 'react'
import { Upload, Icon, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { ACCEPT, isAllowedType, isAllowedSize } from '../../utils/fileValidation'

const { Dragger } = Upload

const sameFile = (a, b) =>
  a.name === b.name && a.size === b.size && a.lastModified === b.lastModified

// Icon standing in for a picked file, by kind.
const fileIcon = (file) => {
  const type = (file && file.type) || ''
  if (type.startsWith('image/')) return 'picture'
  if (type.startsWith('video/')) return 'video-camera'
  if (type.startsWith('audio/')) return 'sound'
  return 'file'
}

const formatSize = (bytes) => {
  if (bytes == null) return ''
  const mb = bytes / 1024 / 1024
  return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`
}

// Body of the "common ad" upload mode: one or more media files, picked or
// dropped. The selection lives in the parent modal (which owns submit and
// reset); this component only validates and reports the next list.
const CommonAdForm = ({ files = [], onChange }) => {
  const { t } = useTranslation()

  // Returning false stops the Dragger from auto-uploading — the selection stays
  // local until the modal's OK. Files accumulate across several drops/picks;
  // duplicates are skipped.
  const beforeUpload = (file) => {
    if (!isAllowedType(file) || !isAllowedSize(file)) {
      message.error(t('Supports JPG, PNG, MP4, MP3 (Max 500MB)'))
      return false
    }
    if (!files.some((item) => sameFile(item, file))) onChange([...files, file])
    return false
  }

  const removeAt = (index) => onChange(files.filter((_, i) => i !== index))

  return (
    <>
      <Dragger multiple accept={ACCEPT} showUploadList={false} beforeUpload={beforeUpload}>
        <div className="dragger-content">
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p>{t('Click to upload or drag your files here')}</p>
          <p className="upload-hint">{t('Supports JPG, PNG, MP4, MP3 (Max 500MB)')}</p>
        </div>
      </Dragger>

      {/* Selected files: visible + removable. The user can keep adding more. */}
      {files.length > 0 && (
        <div className="selected-files">
          <div className="selected-files-head">
            {t('{{count}} files selected', { count: files.length })}
          </div>
          <div className="selected-files-list">
            {files.map((file, index) => (
              <div className="selected-file" key={`${file.name}-${file.size}-${index}`}>
                <Icon type={fileIcon(file)} className="file-icon" />
                <span className="file-name" title={file.name}>
                  {file.name}
                </span>
                <span className="file-size">{formatSize(file.size)}</span>
                <Icon
                  type="close"
                  className="file-remove"
                  title={t('Remove')}
                  onClick={() => removeAt(index)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default CommonAdForm
